import React, { useEffect, useState } from 'react';
import { useTheme } from '../theme-system/ThemeContext';

/* Slim glass header: menu · name on the left, Work · Contact · theme on the right.
   Exactly 64px tall (the layout reserves 64px). Turns a touch more solid once the page scrolls. */
const iconBtn = {
  width: 40, height: 40, borderRadius: 12, border: 'none', background: 'transparent', color: 'var(--text-primary)',
  display: 'grid', placeItems: 'center', cursor: 'pointer', transition: 'background .2s ease'
};
const hover = (e) => { e.currentTarget.style.background = 'var(--bg-accent)'; };
const leave = (e) => { e.currentTarget.style.background = 'transparent'; };

const Header = ({ onToggleSidebar, isMobile }) => {
  const { isDark, toggleTheme } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 8);
    on(); window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);
  const link = { color: 'var(--text-secondary)', textDecoration: 'none', fontSize: 14, fontWeight: 500, padding: '8px 12px', borderRadius: 10, transition: 'color .2s ease, background .2s ease' };
  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, height: 64, boxSizing: 'border-box',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 clamp(12px, 3vw, 28px)',
      background: `color-mix(in srgb, var(--bg-primary) ${scrolled ? 86 : 70}%, transparent)`,
      backdropFilter: 'saturate(160%) blur(16px)', WebkitBackdropFilter: 'saturate(160%) blur(16px)',
      borderBottom: `1px solid ${scrolled ? 'var(--border-color)' : 'transparent'}`, transition: 'background .25s ease, border-color .25s ease'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={onToggleSidebar} aria-label="Menu" style={iconBtn} onMouseEnter={hover} onMouseLeave={leave}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 8h16M4 16h10" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" /></svg>
        </button>
        <a href="/" style={{ textDecoration: 'none', color: 'var(--text-primary)', display: 'flex', alignItems: 'baseline', gap: 10 }}>
          <span style={{ fontSize: isMobile ? 16 : 17, fontWeight: 650, letterSpacing: '-0.02em' }}>Fahad Nimer</span>
          {!isMobile && <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Product builder & creative director</span>}
        </a>
      </div>
      <nav style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {!isMobile && <>
          <a href="/" style={link} onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--text-primary)'; hover(e); }} onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-secondary)'; leave(e); }}>Work</a>
          <a href="mailto:fahadnimer1@gmail.com" style={link} onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--text-primary)'; hover(e); }} onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-secondary)'; leave(e); }}>Contact</a>
        </>}
        <button onClick={toggleTheme} aria-label={isDark ? 'Light mode' : 'Dark mode'} style={iconBtn} onMouseEnter={hover} onMouseLeave={leave}>
          {isDark
            ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" /><path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M5.3 18.7l1.6-1.6M17.1 6.9l1.6-1.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
            : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg>}
        </button>
      </nav>
    </header>
  );
};

export default Header;
